import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import OneQuickBuy from '@/modules/module-oneQuickBuy';
import 'slick-carousel';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init shop-all page');
        
        var self = this;
        self.$content = self.$el;
        self.$body = $('body');

        self.$quickBuyModule = self.$content.find('.shopallmodule.quickbuy');
        self.quickBuy = false;
        self.$module2 = self.$content.find('.shopallmodule.module-2');

        if (self.$quickBuyModule.length > 0) {
            self.quickBuyModules();
        }

        if (self.$module2.length > 0) {
            self.module2Slider();
        }

    },

    events: {
        
    },

    quickBuyModules: function() {
        var self = this;
        self.quickBuy && self.quickBuy.destroy();
        self.quickBuy = OneQuickBuy.init({ el: self.$content });
    },

    module2Slider: function() {
        var self = this;
        var $promoSlider = self.$module2.find('.promo-slider.slick');

        if ($promoSlider.length > 0) {
            // Promo cards slider
            $promoSlider.slick({
                dots: false,
                infinite: false,
                speed: 600,
                slidesToShow: 4,
                arrows: false,
                rows: 0,
                responsive: [
                    {
                        breakpoint: ORW.responsiveSizes.large,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    },

    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});